import React from 'react';
import { TextAreaForm } from "../../components"
import { TypingParagraph } from '../../utils';
import { TFunction } from 'i18next';
import { typeProcess } from '../../components/type';


interface AreaProps {
    state: {
        autorisation: boolean;
        answer: string;
        interviewId: string;
    };
    handleChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
    sendAnswer: (e: React.MouseEvent<HTMLButtonElement>, interviewwId: string | undefined, answer: string, idLastAnwser: string) => void;
    interviewwId: string | undefined;
    idLastAnwser: string;
    tag: () => boolean;
    t: TFunction;
    spinner: boolean;
    isInputBlocked: boolean;
    swimlanes: any[];
    role: string;
    time: Number;
    updateAnswer: (answer: string) => void;
    recognition?: boolean
    file?: File | null
    isAudioFinished?: Boolean
    processType: typeProcess
    isCampaignMode?: boolean
    isFileUploading?: boolean
    onFilePaste?: (file: File) => void;
    shouldHideTextarea?: boolean;
    currentQuestionStep?: number[];
    useModernLayout?: boolean;
    voiceLocksTextInput?: boolean;
    /** When set (e.g. AI interview), input mic starts OpenAI Realtime instead of browser dictation. */
    onVoiceConversationClick?: () => void | Promise<void>;
}

const Area = (props: AreaProps) => {
    const {
        state,
        handleChange,
        sendAnswer,
        interviewwId,
        idLastAnwser,
        tag,
        t,
        spinner,
        isInputBlocked,
        swimlanes,
        role,
        time,
        updateAnswer,
        recognition,
        file,
        isAudioFinished,
        processType,
        isCampaignMode = false,
        isFileUploading = false,
        onFilePaste,
        shouldHideTextarea = false,
        currentQuestionStep,
        useModernLayout = false,
        voiceLocksTextInput = false,
        onVoiceConversationClick,
    } = props

    const [isFocused, setIsFocused] = React.useState(false);

    const messages: string[] = [
        t('views.processInterview.s1', { time }),
        t('views.processInterview.s2', { time }),
        t('views.processInterview.s3', { time }),
    ];



    const handleFocus = () => {
        setIsFocused(true);
    };

    const handleBlur = () => {
        setIsFocused(false);
    };


    const isButtonEnabled =
        (state.answer.trim().length > 0 || !!file) && !isFileUploading && !voiceLocksTextInput;

    const getPlaceholderText = (): string => {
        if (isCampaignMode) {
            return `${t('campaigns.objectivePlaceholder')}...`;
        }
        
        // For IMAGE workflow, only show special text for step [5,1] (first question after upload)
        if (processType === "IMAGE" && currentQuestionStep && currentQuestionStep[0] === 5 && currentQuestionStep[1] === 1) {
            return `${t('views.processInterview.pasteTranscriptInstruction')}...`;
        }
        
        // For HUMAN workflow, show special text for step [4,1] (first question after upload)
        if (processType === "HUMAN" && currentQuestionStep && currentQuestionStep[0] === 4 && currentQuestionStep[1] === 1) {
            return `${t('views.processInterview.pasteTranscriptInstruction')}...`;
        }
        
        // For all other cases (AI, and other HUMAN/IMAGE steps), show simple "Response..."
        return `${t('views.processInterview.responseSimple')}...`;
    };

    const inputContent = (
        <>
            {state.autorisation && tag() && !isInputBlocked && !shouldHideTextarea && (
                <TextAreaForm
                    name={"area"}
                    sendButton={isButtonEnabled}
                    label=""
                    rows={1}
                    classNameArea={useModernLayout ? 'input-field' : `w-100 bg-transparent text-white text-bg-dark py-2 px-3 mb-3  rounded-${state.answer?.length < 100 ? 4 : 2} border border-0`}
                    classNameContainer={useModernLayout ? 'input-inner' : `w-100 message-box ${isFocused && "border-theme"} rounded-${state.answer?.length < 100 ? 5 : 3}`}
                    placeholder={
                        voiceLocksTextInput
                            ? t("views.processInterview.voiceLocksInputPlaceholder", {
                                  defaultValue: 'To type instead, click "Stop voice".',
                              })
                            : getPlaceholderText()
                    }
                    onChange={handleChange}
                    value={state.answer}
                    interviewId={state.interviewId}
                    sendAnswer={(e) => sendAnswer(e, interviewwId, state.answer, idLastAnwser)}
                    spinner={spinner}
                    maxRows={10}
                    minRows={1}
                    button={true}
                    readOnly={isInputBlocked || voiceLocksTextInput}
                    updateAnswer={updateAnswer}
                    handleFocus={handleFocus}
                    handleBlur={handleBlur}
                    recognition={recognition && !voiceLocksTextInput}
                    isAudioFinished={isAudioFinished}
                    onFilePaste={onFilePaste}
                    useModernLayout={useModernLayout}
                    onVoiceConversationClick={onVoiceConversationClick}
                />
            )}
            {!useModernLayout && !tag() && !swimlanes[0]?.is_finish && role === "ADMIN" && swimlanes.length > 0 && (
                <div className="text-light opacity-50 w-100 mt-3">
                    <TypingParagraph
                        messages={messages}
                        delayBetweenMessages={8000}
                        typingSpeed={50}
                        className="fs-6 w-100"
                    />
                </div>
            )}
            {!useModernLayout && state.autorisation && tag() && !isInputBlocked && !shouldHideTextarea && (
                <div className='pt-1 mt-0 px-2 opacity-75  d-flex flex-column justify-content-center align-items-center custom_fontSize d-none d-md-block ' style={{ color: "#6B7280" }}>
                    <span >{t('views.processInterview.pleaseEnsure')}</span> <br />
                    <span >{t('views.processInterview.tip')}</span>
                </div>
            )}
            {useModernLayout && state.autorisation && tag() && !isInputBlocked && !shouldHideTextarea && (
                <div className="interview-input-hints">
                    <span>{t('views.processInterview.pleaseEnsure')}</span>
                    <span>{t('views.processInterview.tip')}</span>
                </div>
            )}
        </>
    );

    return (
        <div className="w-100">
            {useModernLayout ? (
                <div className="input-bar">
                    {inputContent}
                </div>
            ) : (
                <div className='w-100'>
                    {inputContent}
                </div>
            )}
        </div>
    );
};

export default Area;
